import SearchIcon from '@mui/icons-material/Search';
import InputAdornment from '@mui/material/InputAdornment';
import TextField from '@mui/material/TextField';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';

/// Search sits in the bar above every screen, because looking for something by name is the
/// most common thing anyone does here.
export default function SearchField() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [term, setTerm] = useState('');

  const submit = (event: React.FormEvent) => {
    event.preventDefault();

    if (term.trim().length > 0) {
      navigate(`/search?q=${encodeURIComponent(term.trim())}`);
    }
  };

  return (
    <form onSubmit={submit}>
      <TextField
        value={term}
        onChange={(event) => setTerm(event.target.value)}
        placeholder={t('search.placeholder')}
        size="small"
        // Two corrections to what the theme gives every field: no label means no room kept
        // for one, or the box is twice as tall as its text and reads as two rows. And a bar
        // is not a form, so it does not take the width of one.
        hiddenLabel
        fullWidth={false}
        sx={{
          width: { xs: 140, sm: 200, md: 260 },
          '& .MuiFilledInput-root': { borderRadius: 999, paddingInlineStart: 1.5 },
        }}
        slotProps={{
          input: {
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon fontSize="small" />
              </InputAdornment>
            ),
          },
        }}
      />
    </form>
  );
}
